import { Button } from "@repo/ui";
import { FC } from "react";

import { useAssociationsInfoContext } from "../../../contexts/editableItemContext";

interface ButtonProps {
	enabled: boolean;
	update: (enabled: boolean) => void;
	disabled?: boolean;
}
export const ToggleButton: FC<ButtonProps> = ({ enabled, disabled, update }) => {
	const { saving } = useAssociationsInfoContext();

	return (
		<Button
			size="medium"
			color={enabled ? "red" : "darkBlue"}
			className="w-16"
			disabled={saving || disabled}
			onClick={() => update(!enabled)}
		>
			{enabled ? "Disable" : "Enable"}
		</Button>
	);
};
